/*
 * 4-Б10 «Сотрудник · отзыв доступа» — числа из макета «Данные клиента и группы - П2»:
 * сетка фактов в две колонки (зазор 6 × 12), подписи цветом вторичного текста, кнопки
 * рядом с переносом (зазор 6), итог — плашкой на утопленном фоне (9 × 12, радиус 8).
 * На телефоне факты встают в одну колонку: две колонки по 160 px не вмещают «Активные входы».
 */

.body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: min(560px, 100%);
  font-size: 12.5px;
  line-height: 1.5;
}

.facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
  margin: 0;
  font-size: 12px;
}

.facts > div {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.facts dt {
  color: var(--text-secondary);
}

.facts dd {
  margin: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.note,
.outcome {
  margin: 0;
  padding: 9px 12px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: 8px;
}

.problem {
  padding: 9px 12px;
  color: var(--danger);
  border: 1.5px solid var(--danger-hover);
  border-radius: 8px;
}

.confirm {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  color: var(--text-brand);
  border: 1.5px solid var(--danger-hover);
  border-radius: 10px;
}

.confirmTitle {
  font-weight: var(--font-weight-semibold);
}

.confirmButtons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.branches {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0;
  margin: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: 4px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

@media (max-width: 767px) {
  .facts {
    grid-template-columns: 1fr;
  }

  .actions > * {
    flex: 1 1 100%;
  }
}
